module.exports = __webpack_public_path__ + "static/Guidebutton_designer-9b271a12b1e401b905ac6d88fea7b5b4.svg";